import { render, staticRenderFns } from "./builderProducts.vue?vue&type=template&id=1155a9b8&scoped=true&"
import script from "./builderProducts.vue?vue&type=script&lang=js&"
export * from "./builderProducts.vue?vue&type=script&lang=js&"
import style0 from "./builderProducts.vue?vue&type=style&index=0&id=1155a9b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155a9b8",
  null
  
)

export default component.exports